import ComingSoon from "@/components/ComingSoon";
import { IMAGES } from "@/data/demo";
import { useSiteContent } from "@/lib/content";

const Equipementier = () => {
  const c = useSiteContent();
  const titleOverride = c("equipementier.title", "");
  return (
    <ComingSoon
      testId="equipementier-page"
      overline={c("equipementier.overline", "Partenariat équipement")}
      title={
        titleOverride
          ? titleOverride.split("\n").map((l) => l.trim()).filter(Boolean).map((l, i) => <span key={i} className="text-white">{l}</span>)
          : [<span key="a" className="text-white">ÉQUIPEMENTIER</span>, <span key="b" className="text-white">SPORTIF</span>]
      }
      description={c("equipementier.description", "Notre offre équipementier pour les clubs et les stagiaires arrive bientôt : tenues personnalisées, packs clubs et matériel aux couleurs 3M Match Pro.")}
      image={IMAGES.boots}
    />
  );
};

export default Equipementier;
